import { render, staticRenderFns } from "./ClinicLogo.vue?vue&type=template&id=28284fd2&scoped=true&"
import script from "./ClinicLogo.vue?vue&type=script&lang=js&"
export * from "./ClinicLogo.vue?vue&type=script&lang=js&"
import style0 from "./ClinicLogo.vue?vue&type=style&index=0&id=28284fd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28284fd2",
  null
  
)

export default component.exports